<template>
    <base-modal :value="value" @input="canceled" body-classes="p-0">
        <card type="secondary" v-if="log"
            header-classes="bg-transparent"
            body-classes="px-lg-4 py-lg-4"
            class="border-0 mb-0">

            <div class="mb-4" v-if="log.data.errors">
                <div v-for="(fields, line) in log.data.errors" :key="line">
                    <h3 v-if="line == '0'">Globally</h3>
                    <h3 v-else>Entry {{ line }}</h3>
                    <ul>
                        <li v-for="(error, field) in fields" :key="field">
                            <span class="font-weight-bold">{{ field }}</span>: {{ error }}
                        </li>
                    </ul>
                </div>
            </div>

            <div class="mb-4" v-if="log.data.feedback && !log.data.feedback.memberships">
                <div v-for="(ids, type) in log.data.feedback" :key="type">
                    <h3>{{ type }}</h3>
                    <ul v-if="ids.length > 0">
                        <li v-for="id in ids" :key="id">{{ id }}</li>
                    </ul>
                    <p v-else>{{ $t('import.nothing') }}</p>
                </div>
            </div>

            <div class="mb-4" v-if="log.data.feedback && log.data.feedback.memberships">

                <h3>new cohorts</h3>
                <ul v-if="log.data.feedback.cohorts.length > 0">
                    <li v-for="cohort in log.data.feedback.cohorts" :key="cohort">{{ cohort }}</li>
                </ul>
                <p v-else>{{ $t('import.nothing') }}</p>

                <h3>memberships</h3>
                <ul v-if="Object.keys(log.data.feedback.memberships).length > 0">
                    <li v-for="(stats, cohort) in log.data.feedback.memberships" :key="cohort">
                        <span class="font-weight-bold">{{ cohort }}:</span>
                        {{ stats.enrolled }} enrolled, {{ stats.withdrawed }} withdrawed, {{ stats.broughtback }} brought back
                    </li>
                </ul>
                <p v-else>{{ $t('import.nothing') }}</p>
            </div>

            <div class="text-center">
                <base-button type="white" @click="canceled">
                    {{ $t('common.close') }}
                </base-button>
            </div>
        </card>
    </base-modal>
</template>

<script>
    export default {
        
        props: {

            value: {
                type: Object,
                required: true
            },

            log: {
                type: Object,
                default: null
            },
        },

        methods: {
            
            canceled() {
                this.$emit('input', {
                    id: this.value.id,
                    show: false,
                })
            },
        }
    }
</script>

<style scoped>

    .modal-title {
        text-transform: uppercase;
    }

</style>